import { Star } from 'src/components/Svg/Star';

interface IStarRatingsProps {
  stars?: number | null;
}
const starsLength = 5;
const yellowStar = '#F2C94C';

export const StarRatings = ({ stars }: IStarRatingsProps) => {
  return (
    <div>
      {[...Array(starsLength)].map((e, i) => {
        if (stars && stars > i) {
          return <Star fill={yellowStar} key={i} />;
        }

        return <Star key={i} />;
      })}
    </div>
  );
};
